import { FormControl, Grid, Skeleton, Stack } from '@mui/material';
import { RadioButtonsGroupProps } from './RadioButtonsGroup.type';
import { SpacedRadioGroup } from './RadioButtonsGroup.style';
import { generateArray } from 'utils/helpers/array.helpers';

export function RadioButtonsGroupSkeleton({
  label,
  placeholder,
  spacing,
  radio_direction,
  useGridLayoutRadio,
  labelDirection,
  optionsLength,
}: Readonly<
  Pick<
    RadioButtonsGroupProps,
    | 'label'
    | 'placeholder'
    | 'spacing'
    | 'radio_direction'
    | 'useGridLayoutRadio'
    | 'labelDirection'
  > & { optionsLength: number }
>) {
  const renderRadioSkeleton = (index: number) => (
    <Stack direction="row" alignItems="center" spacing={1} key={index}>
      <Skeleton variant="circular" width={20} height={20} />
      <Skeleton variant="text" width={80} height={25} />
    </Stack>
  );

  return (
    <FormControl>
      <Stack
        direction={labelDirection}
        alignItems={labelDirection === 'row' ? 'center' : 'flex-start'}
        spacing={1}
      >
        {label && <Skeleton variant="text" width={120} height={24} />}
        {placeholder && <Skeleton variant="text" width={200} height={20} />}
        <SpacedRadioGroup row spacing={spacing ?? 1} radio_direction={radio_direction}>
          {useGridLayoutRadio ? (
            <Grid container spacing={useGridLayoutRadio.spacingContainer} padding={2}>
              {generateArray(optionsLength).map((_, i) => (
                <Grid item xs={useGridLayoutRadio.xsItem} key={i}>
                  {renderRadioSkeleton(i)}
                </Grid>
              ))}
            </Grid>
          ) : (
            generateArray(optionsLength).map((_, i) => renderRadioSkeleton(i))
          )}
        </SpacedRadioGroup>
      </Stack>
    </FormControl>
  );
}
